import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';

function About({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1>{t('about_title')}</h1>
      <p>{t('about_p1')}</p>
      <p>{t('about_p2')}</p>
      <button className="back-button" onClick={onBack}>{t('back_to_home')}</button>
    </div>
  );
}
export default About;
